<template>
  <d-card :class="['card-small d-inline-flex', { 'show': show }]" :style="{ 'top': `${positionTop}px`, 'left': `${positionLeft}px` }">
    <d-card-body class="px-2 py-0">
      <d-form-row>
        <d-col class="form-group">
          <label>Posição</label>
          <d-select v-model="cell.arrow_position">
            <option value="">Selecione a posição</option>
            <option
              :value="option"
              v-for="option in positionAvallable"
              :key="option.id"
            >{{ option.name }}</option>
          </d-select>
        </d-col>
        <d-col class="form-group">
          <label>Direção</label>
          <d-select v-model="cell.arrow_direction">
            <option value="">Selecione a posição</option>
            <option
              :value="option"
              v-for="option in directionAvallable"
              :key="option.id"
            >{{ option.name }}</option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col class="d-flex justify-content-end">
          <d-button type="button" @click="save()">Salvar</d-button>
        </d-col>
      </d-form-row>
    </d-card-body>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import {
  CELL,
  ARROW,
  CELL_SIZE,
  _PUZZLE_ARROW_OPTION_,
  _PUZZLE_CLOSE_ALL_MODAL_,
} from '../PuzzleModel';

export default {
  name: 'puzzle-option-arrow-modal',
  computed: {
    puzzle() {
      const { puzzle } = this.$store.state.puzzle;
      if (puzzle) {
        return puzzle;
      }
      return false;
    },
    arrowPositions() {
      const { arrowPositions } = this.$store.state.puzzle;
      if (arrowPositions) {
        return arrowPositions;
      }
      return [cloneDeep(ARROW)];
    },
    arrowDirections() {
      const { arrowDirections } = this.$store.state.puzzle;
      if (arrowDirections) {
        return arrowDirections;
      }
      return [cloneDeep(ARROW)];
    },
    positionAvallable() {
      return this.arrowPositions.filter(arrow => {
        if (arrow.slug) {
          const direction = arrow.slug.split('_');
          const initial = direction[0];
          const last = direction.pop();
          if (this.puzzle) {
            return this[initial](arrow) && this[last](arrow) && this.mergedCell(direction, arrow);
          }
        }

        return false;
      });
    },
    directionAvallable() {
      const { slug: position } = (this.cell.arrow_position) ? this.cell.arrow_position : cloneDeep(ARROW);
      const directions = (position) ? position.split('_') : [];
      const invertedPosition = {
        top: 'bottom',
        left: 'right',
        right: 'left',
        bottom: 'top',
      };

      return this.arrowDirections.filter(arrow => {
        if (position === null) return arrow;
        if (invertedPosition[directions[0]] !== arrow.slug) {
          if (position.indexOf('diagonal') > -1 && invertedPosition[directions[2]] === arrow.slug) {
            return false;
          }
          return arrow;
        }
        return false;
      });
    },
  },
  data() {
    return {
      positionTop: 0,
      cell: cloneDeep(CELL),
      positionLeft: 0,
      show: false,
      height: null,
    };
  },
  methods: {
    ...mapActions([
      'getArrowDirections',
      'getArrowPositions',
    ]),
    mergedCell(direction, arrow) {
      if (direction[1] && direction[1].includes('second')) {
        if (
          (Number.isNaN(Number(this.cell.positiony)) || this.cell.type.includes('rowspan')) ||
          (Number.isNaN(Number(this.cell.positionx)) || this.cell.type.includes('colspan'))
        ) {
          return arrow;
        }
        return false;
      }
      return true;
    },
    top(item) {
      let { positiony } = this.cell;
      if (Number.isNaN(Number(positiony))) {
        positiony = Number(positiony.split('_').shift());
      }
      if (positiony !== 0) {
        return item;
      }
      return false;
    },
    bottom(item) {
      let { positiony } = this.cell;
      if (Number.isNaN(Number(positiony))) {
        positiony = Number(positiony.split('_').shift());
      }
      if (positiony < this.puzzle.rows) {
        return item;
      }
      return false;
    },
    right(item) {
      if (this.cell.positionx !== this.puzzle.columns - 1) {
        return item;
      }
      return false;
    },
    left(item) {
      if (this.cell.positionx !== 0) {
        return item;
      }
      return false;
    },
    save() {
      this.cell.arrow_position_id = this.cell.arrow_position.id;
      this.cell.arrow_direction_id = this.cell.arrow_direction.id;
      this.cell.updated = true;
      this.close();
    },
    close() {
      this.show = false;
    },
    getOptions() {
      if (!this.$store.state.puzzle.arrowDirections) {
        this.getArrowDirections();
      }
      if (!this.$store.state.puzzle.arrowPositions) {
        this.getArrowPositions();
      }
    },
  },
  destroyed() {
    Events.$off(_PUZZLE_ARROW_OPTION_);
    Events.$off(_PUZZLE_CLOSE_ALL_MODAL_);
  },
  mounted() {
    this.getOptions();
    Events.$on(_PUZZLE_ARROW_OPTION_, cell => {
      this.cell = cell;
      this.show = cell.active;
      this.positionTop = ((cell.positiony * CELL_SIZE) - 102);
      this.positionLeft = ((cell.positionx * CELL_SIZE) + (CELL_SIZE / 2)) - 110;
    });
    Events.$on(_PUZZLE_CLOSE_ALL_MODAL_, () => {
      this.close();
    });
  },
};
</script>

<style lang="scss" scoped>
  .card-small {
    visibility: hidden;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1199;
    transition: all .5 ease-in;
    background: #d7d7d7;
    width: 230px;
    &:before {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -8px;
      border-width: 8px;
      border-style: solid;
      border-color: #d7d7d7 transparent transparent transparent;
    }
    &.show {
      visibility: visible;
      transition: all .5 ease-in;
    }
  }
</style>
